import { styled } from "styled-components";

const top1000Styles = {
  Container: styled.div`
    display: flex;
    margin: 0 1rem;
    padding: 1rem;
    align-items: center;
    gap: 0.5rem;
    border-radius: 0.75rem;
    background: ${({ theme }) => theme.colors.surfaceScores};
    justify-content: space-between;
    & > svg {
      flex-shrink: 0;
      width: 1.25rem;
      height: 1.25rem;
    }

    & > p {
      &:first-of-type {
        color: ${({ theme }) => theme.colors.black};
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 140%;
        max-width: 11rem;
      }
      &:last-of-type {
        flex: 1;
        color: ${({ theme }) => theme.colors.pink};
        text-align: end;
        text-shadow: 2.139px 2.139px 0px ${({ theme }) => theme.colors.pink};
        -webkit-text-stroke: 1px black;
        font-family: ${({ theme }) => theme.fonts.grotesk};
        font-size: 1.75rem;
        font-weight: 900;
        line-height: 2.75rem;
        letter-spacing: -0.02625rem;
      }
    }
  `,
};

const overallStyles = {
  Container: styled.div`
    display: flex;
    padding: 0rem 1rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    & > svg {
      flex-shrink: 0;
      width: 1.25rem;
      height: 1.25rem;
    }

    & > p {
      color: ${({ theme }) => theme.colors.black};
      font-size: 0.875rem;
      font-weight: 600;
      line-height: 140%;
    }
  `,
};

export { top1000Styles, overallStyles };
